import { useState, type ChangeEvent } from "react";
import { FaChevronRight } from "react-icons/fa6";
import { Sheet } from "react-modal-sheet";

import timezones from "timezones-list";

import { Field } from "shared/ui/field";
import { SearchInput } from "shared/ui/search-input";

import { Option } from "./option";

type Props = { tzCode: string; onSelect: (tzCode: string) => void };

export const SelectTimeZone = (props: Props) => {
  const { tzCode, onSelect } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
  };

  const filteredZones = timezones.filter((zone) => {
    return zone.label.toLowerCase().includes(search.toLowerCase());
  });

  const currentZone = timezones.find((zone) => zone.tzCode === tzCode);

  return (
    <>
      <Field
        as="button"
        className="cursor-pointer flex-row hover:brightness-125"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <div className="inline-flex text-lg leading-5.5 font-medium tracking-[0.4px] text-white">
          Time Zone
        </div>

        <div className="text-pale-grey ml-auto flex items-center gap-x-1">
          <span>{currentZone?.label}</span>

          <FaChevronRight className="size-4" />
        </div>
      </Field>
      <Sheet
        unstyled
        detent="full"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <Sheet.Container className="bg-black px-4 pt-5">
          <Sheet.Header className="flex flex-col pb-2">
            <h3 className="mb-3 flex text-[26px] leading-6 font-semibold tracking-[0.45px]">
              Time Zone
            </h3>
            <div className="mt-3 flex grow items-center gap-x-3">
              <SearchInput
                value={search}
                onChange={handleSearchChange}
                onCancel={() => setSearch("")}
              />

              <button
                className="text-clear-blue inline-flex cursor-pointer leading-5.5 tracking-[0.4px] transition-colors hover:brightness-110"
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </button>
            </div>
          </Sheet.Header>
          <Sheet.Content className="flex grow flex-col">
            <ul className="flex flex-col overflow-y-scroll">
              {filteredZones.map((zone) => {
                return (
                  <Option
                    key={zone.tzCode}
                    title={zone.label}
                    isActive={tzCode === zone.tzCode}
                    onClick={() => {
                      setIsOpen(false);
                      onSelect(zone.tzCode);
                    }}
                  />
                );
              })}
            </ul>
          </Sheet.Content>
        </Sheet.Container>
      </Sheet>
    </>
  );
};
